exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/less-loader?{modifyVars:{"@font-family":"'Source Sans Pro', Helvetica, Arial, sans-serif","@purple":"#5A17EE","@blue":"#00C4ED","@light-purple":"#9469F0","@light-blue":"#51DBF8","@primary-color":"@purple","@highlight-color":"@light-purple","@normal-color":"#d9d9d9","@font-size-base":"12px","@border-radius-base":"0px","@border-color-base":"#e7e7e7","@link-color":"@blue","@link-hover-color":"@light-blue","@link-active-color":"@blue","@btn-font-weight":"600","@btn-primary-color":"#fff","@btn-font-size":"13px","@btn-padding-base":"6px 16px","@btn-border-radius-base":"16px","@btn-default-bg":"@blue","@btn-default-color":"#fff","@btn-default-border":"@blue","@input-hover-border-color":"@light-purple"}}!./~/antd/lib/locale-provider/style/index.less
// module id = 503
// module chunks = 0